import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

/**
 * Gate for authenticated routes.
 *
 * Renders a loading state while the session is being resolved, redirects
 * unauthenticated users to `/login`, and otherwise renders the nested route
 * via <Outlet />.
 */
export function ProtectedRoute() {
  const { status } = useAuth();

  if (status === "loading") {
    return <div className="app-loading">Loading…</div>;
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
